import AdminCreateInstructorLayout from "@Organism/Admin/Instructor/Create";

export default function AdminCreateInstructorPage({ isEdit }) {
  return <AdminCreateInstructorLayout isEdit={isEdit} />;
}
